import { createSelector } from 'reselect';
import { isEmpty, get, map, reject, where } from 'lodash/fp';

import headToHeadSelector from './headToHeadSelector';
import { IN_PROGRESS } from '../constants/challengeStatusTypes';

const rejectCommon = reject(
  ([x, y]) =>
    x &&
    y &&
    x.idStr === y.idStr &&
    get('bonus.key', x) === get('bonus.key', y) &&
    y.statusId >= IN_PROGRESS
);
const rejectEmpty = reject(where({ entities: isEmpty }));

const difference = map(pos => ({
  ...pos,
  entities: rejectCommon(pos.entities)
}));

function getPerformance(hthList, diffOnly) {
  return rejectEmpty(diffOnly ? difference(hthList) : hthList);
}

const performanceSelector = createSelector(
  headToHeadSelector,
  get('entry.restrictToUnique'),
  getPerformance
);

export default performanceSelector;
